import type { ShaderStyle } from "~/lib/types";
import type { NodeDefinition } from "~/nodes/types";

/** Varyings and uniforms supplied by the viewer's vertex shader. */
const DEFAULT_FRAGMENT = `varying vec3 _position;
varying vec3 _normal;
varying vec2 _uv;
uniform float frame;

void main() {
  gl_FragColor = vec4(
    0.2 + 0.8 * _position.x,
    0.2 + 0.8 * _position.y,
    0.2 + 0.8 * _position.z,
    1.0
  );
}
`;

export const shaderStyleNode: NodeDefinition = {
  type: "shaderStyle",
  label: "Shader Style",
  category: "Style",
  width: 420,
  inputs: [],
  outputs: [{ key: "style", label: "Style", socket: "style" }],
  controls: [
    { kind: "code", key: "fragment", label: "fragment shader", rows: 12 },
  ],
  defaults: { fragment: DEFAULT_FRAGMENT },

  compute(ctx) {
    const style: ShaderStyle = {
      type: "shader",
      fragment: String(ctx.data["fragment"] ?? DEFAULT_FRAGMENT),
    };

    return { style };
  },
};
